var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJubilee = function SvgJubilee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.803 6.71c.515 3.605-1.725 8.81-5.24 9.313-3.516.502-6.974-3.89-7.49-7.495-.514-3.605 1.918-6.935 5.433-7.437s6.782 2.013 7.297 5.619M11.031 16.5s-.193 3.939 2.969 3.939c3 0 5 2.461 5 2.461"
  })));
};
export default SvgJubilee;